// storybook-ignore: beteendekomponent (scroll to top) som returnerar null — ingen visuell yta. Avsiktligt utan story, räkna den inte som saknad.
import * as React from 'react';
import {useEffect} from 'react';
import {useLocation} from 'react-router';

export const ScrollToTop: React.FunctionComponent = () => {

    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return null;
};

